import { c as _c } from "react/compiler-runtime";
import React from 'react';
// It is safe to use this package here, because it is available in the new
// consumer app, and in the old package a mock is used.
// eslint-disable-next-line import/no-unresolved
import useCarouselFix from 'use-carousel-fix';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import isNewConsumerApp from 'commons/isNewConsumerApp';
function cls(...classes) {
  return classes.filter(Boolean).join(' ');
}
const CustomCarouselArrows = t0 => {
  const $ = _c(37);
  const {
    variant,
    side,
    onNavigate
  } = t0;
  const isLeft = side === "left";
  const isRight = side === "right";
  const {
    currentPage,
    totalPages,
    wrapMode,
    goBack,
    goForward
  } = useCarouselFix();
  if (onNavigate) {
    const t1 = variant === "blog-slider" && "rounded-none";
    const t2 = isRight && "right-2.5";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
      t3 = cls("relative w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white", "[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray", "group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]", t1, t2);
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    const navClassName = t3;
    let t4;
    if ($[3] !== isLeft) {
      t4 = isLeft ? <IconArrowLeftWhite /> : <IconArrowRightWhite />;
      $[3] = isLeft;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== navClassName || $[6] !== onNavigate || $[7] !== t4) {
      t5 = <button type="button" className={navClassName} onClick={onNavigate}>{t4}</button>;
      $[5] = navClassName;
      $[6] = onNavigate;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  const allowWrap = wrapMode === "wrap";
  const enablePrevNavButton = allowWrap || currentPage > 0;
  const enableNextNavButton = allowWrap || currentPage < totalPages - 1;
  const t1 = variant === "material-swatches-sidebar" ? "static w-[50px] h-[50px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent outline-0 !bg-transparent !border-0 pointer-events-auto" : "static w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white pointer-events-auto";
  const t2 = variant !== "material-swatches-sidebar" && "[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray";
  const t3 = variant !== "material-swatches-sidebar" && "group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]";
  const t4 = enablePrevNavButton && "!visible";
  const t5 = variant === "blog-slider" && "rounded-none";
  let t6;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = cls(t1, t2, t3, t4, t5, isNewConsumerApp && "md:ml-2");
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const prevNavClassName = t6;
  const t7 = variant === "material-swatches-sidebar" ? "static w-[50px] h-[50px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent outline-0 !bg-transparent !border-0 pointer-events-auto" : "static w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white pointer-events-auto";
  const t8 = variant !== "material-swatches-sidebar" && "[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray";
  const t9 = variant !== "material-swatches-sidebar" && "group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]";
  const t10 = enableNextNavButton && "!visible";
  const t11 = variant === "blog-slider" && "rounded-none";
  let t12;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t12 = cls(t7, t8, t9, t10, t11, isNewConsumerApp && "lg:mr-2");
    $[15] = t10;
    $[16] = t11;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const nextNavClassName = t12;
  const t13 = variant === "material-swatches-sidebar" && "top-1/2 left-0 right-0 -translate-y-1/2 justify-between px-2 pointer-events-none";
  const t14 = variant !== "blog-slider" && variant !== "material-swatches-sidebar" && "justify-between -translate-y-[630%]";
  const t15 = variant === "blog-slider" && "justify-end gap-4 -translate-y-[940%]";
  let t16;
  if ($[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
    t16 = cls("absolute w-full flex", t13, t14, t15);
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconArrowLeftWhite />;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== goBack || $[27] !== prevNavClassName) {
    t18 = <button type="button" className={prevNavClassName} onClick={goBack}>{t17}</button>;
    $[26] = goBack;
    $[27] = prevNavClassName;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconArrowRightWhite />;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== goForward || $[31] !== nextNavClassName) {
    t20 = <button type="button" className={nextNavClassName} onClick={goForward}>{t19}</button>;
    $[30] = goForward;
    $[31] = nextNavClassName;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t16 || $[34] !== t18 || $[35] !== t20) {
    t21 = <div className={t16}>{t18}{t20}</div>;
    $[33] = t16;
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
};
export default CustomCarouselArrows;